require('gsap');
require('./desktop/Main');
// eslint-disable-next-line import/no-unresolved
require('javascripts/trill-description/dist/scripts/main');
